import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import {
  CalculationListResponse,
  GetCalculationParams,
  ListCalculationsParams,
  TaxCalculationResponse,
} from './types';

export function useCalculations({
  filters,
  cursor = null,
  limit = 10,
}: ListCalculationsParams) {
  const query = new URLSearchParams();

  if (filters.corporationId) {
    query.append('corporationId', filters.corporationId.toString());
  }

  if (cursor) {
    query.append('cursor', cursor);
  }

  if (filters.from_date) {
    query.append('from_date', filters.from_date);
  }

  if (filters.to_date) {
    query.append('to_date', filters.to_date);
  }

  if (filters.search_term) {
    query.append('search_term', filters.search_term);
  }

  query.append('limit', limit.toString());

  const { data, error, isLoading, mutate } = useSWR<CalculationListResponse>(
    `new-sales-tax/internal/calculations?${query}`,
    SWRFetcher(
      {
        method: 'GET',
      },
      undefined
    )
  );

  return {
    calculations: data?.data ?? [],
    cursor: data?.nextCursor,
    totalCalculations: data?.totalCalculations ?? 0,
    error,
    mutate,
    isLoading,
  };
}

export function useCalculation({
  calculationId,
  corporationId,
}: GetCalculationParams) {
  const query = new URLSearchParams();
  query.append('corporationId', corporationId.toString());

  const { data, error, isLoading, mutate } = useSWR<TaxCalculationResponse>(
    `new-sales-tax/internal/calculations/${calculationId}?${query}`,
    SWRFetcher(
      {
        method: 'GET',
      },
      undefined
    )
  );

  return {
    calculation: data,
    error,
    mutate,
    isLoading,
  };
}
